import CardPage2 from "./cardPage2";
import Title2 from "./title2";



export default function  Page2(){
return(
    <>
    <Title2/>
    <CardPage2/>
    </>
)
}